export default "__VITE_ASSET__CrUwbk7Y__"